import { MatDialog } from '@angular/material/dialog';
import { DocumentValue } from '../../model/document-value';
import { Document } from '../../model/document';
import { TemplateAttribute } from '../../model/template-attribute';
import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { TemplateAttributeMode } from '../../model/template-attribute-mode.enum';
import { AppClientConfiguration, AppServerAPI, ImagePreviewDialog, TranslationService } from '@sdbn/common';

@Component({
    selector: 'app-template-attribute-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    standalone: false
})
export class AttributeImageComponent implements OnInit {

  attributeMode = TemplateAttributeMode;


  images = new Array<string>();

  documentValue: DocumentValue = null;

  @Input() document: Document;
  @Input() templateAttribute: TemplateAttribute;

  @Input() metaData: any;

  /** Shows loading spinner i.e. when deletion is triggered and validation request is running. */
  requestRunning = false;


  constructor(
    private appServerAPI: AppServerAPI,
    private matDialog: MatDialog,
    public translationService: TranslationService,
    private appClientConfiguration: AppClientConfiguration
  ) { }

  ngOnInit(): void {
    this.extractDocumentValueByKey();
    this.readImagesFromDocumentValue();
  }

  handleDocumentPictureEvent(event: Event) {
    this.requestRunning = true;
    const files = (event.target as HTMLInputElement).files;
    if (files != null) {
      for (let i = 0; i < files.length; i++) {
        const current: File = files.item(i);
        const name = current.name;
        const type = current.type;
        const reader = new FileReader();
        // Callback handler must be registered before calling readAsArrayBuffer
        reader.onload = () => {
          this.uploadImage(type, name, reader.result);
        };
        reader.readAsArrayBuffer(current);

      }
    }
  }

  public showImagePreview(resourceUUID: string) {
    const dialogRef = this.matDialog.open(ImagePreviewDialog,
      {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '96%',
        width: '96%',
        panelClass: 'tmc-dialog-container'
      });
    dialogRef.componentInstance.imageSrc = this.createUrl(resourceUUID);
    dialogRef.componentInstance.dialogRef = dialogRef;
    dialogRef.afterClosed()
      .subscribe(result => { });

    //this.applicationRef.tick();
  }

  public createPreviewUrl(resourceId: string): string {
    return this.createUrl(resourceId) + '?type=thumb';
  }

  createUrl(resourceId: string): string {
    return this.appClientConfiguration.serverURLRoot + '/client/resource/archive/' + resourceId;
  }

  removeImage(resourceUUID: string) {
    return this.appServerAPI.execute('/client/document/image/remove', resourceUUID).subscribe(response => {
      console.log('removeImage call succeeded:', response);
      this.requestRunning = false;
      this.images.splice(this.images.indexOf(resourceUUID), 1);
      this.syncToDocument();
    }, error => {
      console.log('removeImage call failed:', error);
      this.requestRunning = false;
    });
  }

  private uploadImage(type: string, fileName: string, content: any): Promise<void> {

    // return this.appServerAPI.postFile('/client/document/image/upload', content, new HttpHeaders({
    //   'Content-Type': type,
    //   'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
    //   transportId: '' + this.document.transportId,
    //   filename: encodeURIComponent(name)
    // })).toPromise().then(response => {
    //   console.log('saveDocument call succeeded:', response);
    //   this.requestRunning = false;
    //   this.addImageToDocument(response['resourceUUID']);
    // }, error => {
    //   console.log('saveDocument call failed:', error);
    //   this.requestRunning = false;
    // });

    this.requestRunning = true;
    let header = new HttpHeaders({
      'Content-Type': type,
      'Content-MD5': 'not yet implemented',
      'usage': 'document-image',
      'filename': encodeURIComponent(fileName)
    });
    if (this.metaData != null) {
      header = header.append('fileMetaData', JSON.stringify(this.metaData));
    }
    console.log('headers are', header);
    return this.appServerAPI.postFile<any>('/app-client/resource/upload', content, header).toPromise().then(response => {
      console.log('saveDocument call succeeded:', response);
      this.requestRunning = false;
      this.addImageToDocument(response['resourceId']);
    }, error => {
      console.log('saveDocument call failed:', error);
      this.requestRunning = false;
    });

  }

  private addImageToDocument(resourceUUID: string) {
    this.images.push(resourceUUID);
    this.syncToDocument();
  }

  private extractDocumentValueByKey() {
    // find document value to store it in
    for (const value of this.document.values) {
      if (value.key === this.templateAttribute.key) {
        this.documentValue = value;
        break;
      }
    }
  }

  private syncToDocument() {
    // Create image string to store in document
    let imageValue = null;
    for (const image of this.images) {
      if (imageValue === null) {
        imageValue = image;
      } else {
        imageValue = imageValue + ';' + image;
      }
    }
    this.documentValue.value = imageValue;
  }

  private readImagesFromDocumentValue() {
    if (this.documentValue.value != null) {
      this.documentValue.value.split(';').forEach(i => {
        if (i != null && i.length > 0) {
          this.images.push(i);
        }
      });
    }
  }

}
